// extracted by mini-css-extract-plugin
export default {"-large":"custom-scaled-dimensions-info-box-module__-large--npLKZ","dimensionsBox":"custom-scaled-dimensions-info-box-module__dimensionsBox--OuWyR"};